import req from "../http";

const workShift = {
  // 取得 班別
  getWorkShift(params) {
    return req("get", "/BasicInformation/WorkShiftType", params);
  }
};

export default workShift;